import { Box, Grid, IconButton, Paper } from '@mui/material'
import { useEffect, useState } from 'react'
import { TextWithLabel } from 'Components/TextWithLabel'
import { LargeCard } from 'Components/Cards/Large'
import { DuplicateHandlingContactEdit } from './DuplicateHandlingContactEdit'
import EditIcon from '@mui/icons-material/Edit'
import { sendGet, sendPost } from 'hooks/use-fetch'
import { toast } from 'react-toastify'

export interface DuplicateHandlingContact {
  name?: string
  email?: string
}

export function DuplicateHandlingContactDisplay (): JSX.Element {
  const [refreshTime, setRefreshTime] = useState<Date>(new Date())
  const [open, setOpen] = useState(false)
  const [contact, setContact] = useState<DuplicateHandlingContact>({ name: '', email: '' })

  useEffect(() => {
    const fetchContact = async (): Promise<void> => {
      const { response, success } = await sendGet('/SiteConfiguration/GetDuplicateHandlingContact', {})
      if (success) {
        setContact(response)
      } else {
        toast.error('Failed to fetch duplicate handling contact')
      }
    }

    void fetchContact()
  }, [refreshTime])

  const handleConfirm = async (updatedContact: DuplicateHandlingContact): Promise<void> => {
    const { success } = await sendPost('/SiteConfiguration/UpdateDuplicateHandlingContact', updatedContact)

    if (success) {
      setRefreshTime(new Date())
      setOpen(false)
    } else {
      toast.error('Failed to update duplicate handling contact')
    }
  }

  const contactContent = <Box className="d-flex">
    <TextWithLabel testId='contact-name' label='Name' name='name' value={contact.name ?? ''} className='mr-5' />
    <TextWithLabel testId='contact-email' label='Email' name='email' value={contact.email ?? ''} className='mr-5' />
  </Box>

  return <Box>
    {open && <DuplicateHandlingContactEdit
      contact={contact}
      onClose={() => { setOpen(false) }}
      show={open}
      onConfirm={handleConfirm}
    />}

    <Paper sx={{ pt: 2, borderRadius: '32px', marginTop: '20px' }}>
      <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'row-reverse' }}>
        <IconButton data-testid="editButton" onClick={() => { setOpen(true) }} >
          <EditIcon />
        </IconButton>
      </Grid>

      <LargeCard header='Duplicate Handling Contact' content={contactContent} className='Borderless' fullWidth={true} />
    </Paper>
  </Box>
}
